<template>
  <header class="sticky-menu" v-if="!loading">
    <router-link :to="{ name: 'Dashboard' }" class="logo-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 820 200" width="160" fill="#fff" ><path class="cls-1" d="M208.56,65.75c20.87,0,38.33,13,42.23,31.59H236.27c-3.67-11-14.53-18.06-27.35-18.06-17.33,0-29.54,12.57-29.54,30.62s12,30.73,29.54,30.73c13.55,0,24.66-7.68,27.83-19.27H206.36V109.29H252c-.36,26.1-18.06,44.88-43.09,44.88S165.1,135.51,165.1,109.9C165.1,84.53,183.53,65.75,208.56,65.75Z"/><path class="cls-1" d="M259.46,119.66c0-19.76,14.65-34.52,33.93-34.52,20.15,0,33.57,15.49,33.57,34.64,0,1.46-.12,3-.24,4.51H273.25c1.59,10.61,9.28,17.2,20.14,17.2,7.82,0,14.29-3.66,17.7-9.64h14.29c-5.25,13.91-17.34,22.32-32,22.32C274.11,154.17,259.46,139.29,259.46,119.66Zm54-6.35c-2.44-10-10-16-20-16-10.25,0-17.57,6.09-19.89,16Z"/><path class="cls-1" d="M338.93,152.59V86.72h9.64l2.32,8.54a26.16,26.16,0,0,1,20.51-10c8.91,0,16,4.39,19.77,11.47a26,26,0,0,1,21.49-11.47c13.91,0,23.31,10.49,23.31,25.49v41.84H422.42V114.05c0-10.62-4.63-16.71-12.81-16.71-8.79,0-15.51,8-15.51,19.27v36H380.8V114.05c0-10.62-4.52-16.71-12.82-16.71-8.79,0-15.5,8-15.5,19.27v36Z"/><path class="cls-1" d="M453.06,152.59V67.21h31.62c16.48,0,29.05,12,29.05,28.17s-12.45,28.18-29.05,28.18H467.1v29Zm14-42.33H484c9.15,0,15.62-6.22,15.62-14.88S493.1,80.5,484,80.5H467.1Z"/><path class="cls-1" d="M519.59,119.66c0-19.88,14.77-34.52,34.43-34.52a33.21,33.21,0,0,1,24,9.76l1.59-8.18h10.5v65.87h-11l-1.34-8.05a32.75,32.75,0,0,1-23.8,9.63C534.36,154.17,519.59,139.41,519.59,119.66Zm13.8,0A21.1,21.1,0,0,0,555,141.24c12.45,0,21.49-9.14,21.49-21.58s-9-21.59-21.49-21.59A21.1,21.1,0,0,0,533.39,119.66Z"/><path class="cls-1" d="M602.11,118a32.9,32.9,0,0,1,56.64-22.69l2.2-8.54h8.91v57.21c0,21.1-12.57,33.9-33,33.9-16.84,0-28.81-8.78-32.22-23.29h13.55c2.56,7.32,10.25,11.22,18.55,11.22,11.48,0,19.78-7.44,19.78-20v-2.93a33.42,33.42,0,0,1-21.85,7.81A32.22,32.22,0,0,1,602.11,118Zm13.8,0c0,11.46,8.66,20.12,20.38,20.12s20.27-8.54,20.27-20.12S648,97.7,636.29,97.7,615.91,106.36,615.91,118Z"/><path class="cls-1" d="M681.83,119.66c0-19.76,14.64-34.52,33.93-34.52,20.14,0,33.57,15.49,33.57,34.64,0,1.46-.12,3-.24,4.51H695.62c1.59,10.61,9.28,17.2,20.14,17.2,7.81,0,14.28-3.66,17.7-9.64h14.28c-5.25,13.91-17.33,22.32-32,22.32C696.47,154.17,681.83,139.29,681.83,119.66Zm53.95-6.35c-2.44-10-10-16-20-16-10.25,0-17.58,6.09-19.9,16Z"/><path class="cls-1" d="M769.59,131.73c.37,7,6.23,10.49,14.17,10.49,7.2,0,12.81-3.05,12.81-8.54,0-6.22-7.08-7.68-15.13-9-11-1.83-23.93-4.39-23.93-19.64,0-11.83,10.25-19.88,25.51-19.88s25.27,8.29,25.51,21.1H795.72c-.25-6.34-5-9.64-12.94-9.64-7.57,0-12.21,3.18-12.21,7.93,0,5.86,6.84,7.08,14.77,8.3,11.11,2,24.66,4,24.66,20.24,0,12.81-10.74,21.1-26.73,21.1s-26.61-8.78-27-22.44Z"/><path class="cls-1" d="M150,22.22,10.76,65.75A1.11,1.11,0,0,0,10,67.13l10.74,35.29a1,1,0,0,0,1.32.72l102.15-32a19.21,19.21,0,0,0,11.35-9.53,226.48,226.48,0,0,0,15.64-38A1,1,0,0,0,150,22.22Z"/><path class="cls-1" d="M116.58,83.26l-86.5,27a1,1,0,0,0-.62,1.18l9.1,29.81a.93.93,0,0,0,1.13.61l55.16-17.26a16.43,16.43,0,0,0,9.61-8,186.5,186.5,0,0,0,13.19-32.17A.89.89,0,0,0,116.58,83.26Z"/><path class="cls-1" d="M83.68,137.77,47.63,149.06a.8.8,0,0,0-.51,1l7.67,25.2a.75.75,0,0,0,1,.51l9.57-3a13.94,13.94,0,0,0,8.13-6.82A157,157,0,0,0,84.6,138.75.73.73,0,0,0,83.68,137.77Z"/></svg>
    </router-link>

    <!-- <UniversalSearch />  -->
    <div class="d-flex flex-grow-1"></div>
    <div class="right-item d-none d-sm-flex">
      <!-- <span v-if="!isOpenHelpCenter" class="tooltip tooltip-top">{{ $t("generals.helpCenter.toolTips")}}</span> -->
      <!-- <div class="right-item" @click="openHelpCenter"> -->
      <div class="button d-flex" :class="{ 'button-disabled': isOpenHelpCenter }" v-popover:tooltip.bottomsidebar="$t('generals.helpCenter.toolTips')" @click.stop="openHelpCenter" id="help-center">
        <i class="icon icon-help"></i>
      </div>
      <div class="drop-down" v-clickaway="closeHelpCenter" :class="{ active: isOpenHelpCenter }">
        <div class="drop-down-menu no-hover">
          <span class="typo-button14 weight-500">{{ $t("pricing.support") }}</span>
        </div>
        <a class="drop-down-menu d-flex align-items-center" @click="openLiveChat()">
          <i class="icon icon-chat mr-2"></i>
          <span class="typo-button14 weight-500">{{ $t("generals.helpCenter.liveChat") }}</span>
        </a>
        <a @click="closeHelpCenter" href="https://help.gempages.net/" class="drop-down-menu d-flex align-items-center" target="_blank">
          <i class="icon icon-help mr-2"></i>
          <span class="typo-button14 weight-500">{{ $t("generals.helpCenter.title") }}</span>
        </a>
      </div>
    </div>
    <!-- <div class="right-item d-none d-sm-flex">
      <div class="right-item" v-clickaway="closeNotiCenter"  @click="openNotiCenter" >
      <span v-if="!isOpenNotiCenter" class="tooltip tooltip-top">{{ $t("generals.notiCenter.toolTips")}}</span>
      <div class="button d-flex" :class="{ 'button-disabled': notiBar.isOpen }" v-popover:tooltip.bottomsidebar="$t('generals.notiCenter.toolTips')" @click="openNoti">
        <i class="icon icon-notification"></i>
      </div>
      <div class="noti-num d-flex align-item-center clickable" :class="{ 'button-disabled': isOpenHelpCenter }" v-if="notiBar.noti_list_unread && notiBar.noti_list_unread > 0" @click.stop="openNoti">
        <span class="text-dark-high">{{ notiBar.noti_list_unread }}</span>
        <span class="text-dark-high" v-else></span>
      </div>
    </div> -->
    <div class="user-info">
      <div class="button" :class="{ 'button-disabled': isOpenUserInfo }" v-popover:tooltip.bottomsidebar="$t('accountSettings.headerTitle')" @click="openUserInfo">
        <div class="avatar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.4247 4.57538C15.3242 0.474873 8.67595 0.474873 4.57544 4.57538C0.474934 8.67589 0.474934 15.3241 4.57544 19.4246C8.67595 23.5251 15.3242 23.5251 19.4247 19.4246C23.5252 15.3241 23.5252 8.67589 19.4247 4.57538ZM20.4853 3.51472C15.799 -1.17157 8.20107 -1.17157 3.51478 3.51472C-1.17151 8.20101 -1.17151 15.799 3.51478 20.4853C8.20107 25.1716 15.799 25.1716 20.4853 20.4853C25.1716 15.799 25.1716 8.20101 20.4853 3.51472Z" fill="#E2E2E2" />
            <path d="M8.55761 18L9.65917 14.8242H14.3467L15.4424 18H17.3642L13.0459 6H10.9541L6.63574 18H8.55761ZM10.1865 13.3008L11.956 8.17968H12.0498L13.8193 13.3008H10.1865Z" fill="#E2E2E2" />
          </svg>
        </div>
        <div class="user-detail">
          <div class="user-name">
            <span class="typo-heading16 typo-medium">{{ info.name }}</span>
          </div>
          <div class="shop-domain">
            <span class="typo-paragraph12 typo-regular">Agency Partner</span>
          </div>
        </div>
      </div>
      <div class="drop-down drop-down-edge" v-clickaway="closeUserInfo" :class="{ active: isOpenUserInfo }">
        <router-link :to="{ name: 'AccountSettings' }" class="drop-down-menu no-hover">
          <span class="typo-button14 weight-500">{{ $t("generals.account.title") }}</span>
        </router-link>

        <router-link :to="{ name: 'AgencySettings' }" @click.native="closeUserInfo" class="drop-down-menu d-flex align-items-center">
          <i class="icon icon-acc-settings mr-2"></i>
          <span class="typo-button14 weight-500">{{ $t("generals.account.accountSetting") }}</span>
        </router-link>
      </div>
    </div>
    <Portal to="tooltip-sidebar">
      <tooltip :pointer="true" :width="'auto'" />
      <!-- <tooltip :name="'noti'" :pointer="true" :width="'auto'" />
      <tooltip :name="'acc'" :pointer="true" :width="'auto'" />-->
    </Portal>
  </header>

  <header class="sticky-menu" v-else>
    <div class="logo-icon">
      <svg width="160" height="24" viewBox="0 0 160 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M49.263 13.3895H44.8841V10.8631H52.1262V11.7053C52.1262 17.8526 48.1683 21.0526 43.5367 21.0526C38.5683 21.0526 34.863 17.3474 34.863 12.2105C34.863 7.07367 38.4841 3.36841 43.5367 3.36841C45.9788 3.36841 47.9999 4.21051 49.5157 5.7263L47.5788 7.66315C46.4841 6.56841 44.9683 5.97894 43.4525 5.97894C40.0841 5.97894 37.5578 8.67367 37.5578 12.1263C37.5578 15.5789 40.0841 18.2737 43.4525 18.2737C46.4841 18.3579 48.7578 16.3368 49.263 13.3895ZM54.8209 20.7158V3.70525H63.1578V6.23157H57.5999V10.5263H63.1578V13.0526H57.5999V18.1053H63.1578V20.6316L54.8209 20.7158ZM66.6946 3.70525H69.3894L74.2736 10.3579L78.9052 3.70525H81.5999V20.6316H78.9052V8.42104L74.2736 14.821L69.3894 8.42104V20.6316H66.6946V3.70525ZM92.4631 3.70525H97.8525C100.8 3.70525 102.905 5.64209 102.905 8.67367C102.905 11.621 100.8 13.6421 97.8525 13.6421H95.1578V20.7158H92.4631V3.70525ZM95.242 6.39999V11.0316H97.7683C99.1999 11.0316 100.126 10.1895 100.126 8.75788C100.126 7.3263 99.1157 6.4842 97.7683 6.4842H95.242V6.39999ZM117.305 20.7158H114.442L112.505 14.821H107.537L105.516 20.7158H102.653L108.631 3.70525H111.41L117.305 20.7158ZM108.379 12.2105H111.663L110.063 7.32631L108.379 12.2105ZM132.716 13.3895H128.337V10.8631H135.579V11.7053C135.579 17.8526 131.621 21.0526 126.989 21.0526C122.021 21.0526 118.316 17.3474 118.316 12.2105C118.316 7.07367 121.937 3.36841 126.989 3.36841C129.432 3.36841 131.453 4.21051 132.968 5.7263L131.032 7.66315C129.937 6.56841 128.421 5.97894 126.905 5.97894C123.453 5.97894 121.01 8.67367 121.01 12.1263C121.01 15.5789 123.537 18.2737 126.905 18.2737C129.937 18.3579 132.21 16.3368 132.716 13.3895ZM138.274 20.7158V3.70525H146.526V6.23157H140.968V10.5263H146.526V13.0526H140.968V18.1053H146.526V20.6316L138.274 20.7158ZM156.463 8.16841C156.463 6.82104 155.705 5.89473 154.442 5.89473C153.179 5.89473 152.253 6.82104 152.253 7.91578C152.253 9.09473 152.758 9.6842 154.442 10.1895L155.2 10.4421C157.979 11.2 160 12.3789 160 15.7474C160 18.8632 157.642 21.0526 154.442 21.0526C151.242 21.0526 148.884 18.8632 148.884 15.4105H151.495C151.495 17.1789 152.758 18.5263 154.442 18.5263C156.21 18.5263 157.389 17.3474 157.389 15.7474C157.389 14.2316 156.463 13.4737 154.442 12.9684L153.684 12.8C150.905 12.0421 149.642 10.4421 149.642 7.99999C149.642 5.22104 151.663 3.45262 154.358 3.45262C157.305 3.45262 158.989 5.13683 158.989 8.25262L156.463 8.16841ZM84.6315 12.2105L86.9894 9.76841L89.3473 12.2105L86.9894 14.6526L84.6315 12.2105Z" fill="#E2E2E2" />
        <path d="M21.2211 0.0842106L0.0842106 6.82106C0.0842106 6.82106 0 6.82106 0 6.90527C0 6.90527 0 6.98948 0 7.07369L1.6 12.4632C1.6 12.4632 1.6 12.4632 1.6 12.5474C1.6 12.5474 1.6 12.5474 1.68421 12.5474C1.68421 12.5474 1.68421 12.5474 1.76842 12.5474H1.85263L17.3474 7.66316C17.6842 7.57895 18.0211 7.32632 18.3579 7.07369C18.6947 6.82106 18.8632 6.48421 19.1158 6.14737C20.0421 4.29474 20.8842 2.27369 21.4737 0.252632V0.168421C21.4737 0.168421 21.4737 0.0842106 21.3895 0.0842106C21.3895 0.0842106 21.3053 0.0842106 21.3053 0C21.3053 0.0842106 21.2211 0.0842106 21.2211 0.0842106Z" fill="#E2E2E2" />
        <path d="M16.1683 9.51589L3.03148 13.6422C3.03148 13.6422 2.94727 13.6422 2.94727 13.7264V13.8106L4.29463 18.358C4.29463 18.358 4.29463 18.358 4.29463 18.4422C4.29463 18.4422 4.29463 18.4422 4.37885 18.4422C4.37885 18.4422 4.37885 18.4422 4.46306 18.4422L12.7999 15.7475C13.1367 15.6633 13.3894 15.4948 13.642 15.2422C13.8946 14.9896 14.0631 14.7369 14.2315 14.4843C15.0736 12.8843 15.7473 11.2843 16.2525 9.51589V9.43168V9.34747C16.2525 9.51589 16.2525 9.51589 16.1683 9.51589C16.1683 9.43168 16.2525 9.43168 16.1683 9.51589Z" fill="#E2E2E2" />
        <path d="M10.4421 18.1055L5.7263 19.6213C5.7263 19.6213 5.64209 19.6213 5.64209 19.7055C5.64209 19.7897 5.64209 19.7897 5.64209 19.7897L6.82104 23.6634C6.82104 23.6634 6.82104 23.6634 6.90525 23.6634C6.90525 23.6634 6.90525 23.6634 6.98946 23.6634L7.74735 23.4108C7.99999 23.3265 8.25262 23.1581 8.50525 22.9897C8.75788 22.8213 8.9263 22.5687 9.01051 22.316C9.6842 20.9687 10.2737 19.5371 10.6947 18.1055V18.0213C10.6947 18.0213 10.6947 18.0213 10.6947 17.9371C10.5263 18.1055 10.5263 18.1055 10.4421 18.1055C10.4421 18.1055 10.5263 18.1055 10.4421 18.1055Z" fill="#E2E2E2" />
      </svg>
    </div>
    <div class="container align-self-center">
      <div class="row">
        <div class="col-12">
          <article class="search-container search-holder"></article>
        </div>
      </div>
    </div>
    <div class="right-item">
      <div class="button">
        <i class="icon icon-help"></i>
      </div>
    </div>
    <!-- <div class="right-item">
      <div class="button">
        <i class="icon icon-notification"></i>
      </div>
    </div> -->
    <div class="user-info user-holder">
      <div class="button">
        <div class="avatar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.182 6.56802C13.4246 4.81066 10.5754 4.81066 8.81802 6.56802C7.06066 8.32537 7.06066 11.1746 8.81802 12.932C10.5754 14.6893 13.4246 14.6893 15.182 12.932C16.9393 11.1746 16.9393 8.32537 15.182 6.56802ZM16.2426 5.50736C13.8995 3.16421 10.1005 3.16421 7.75736 5.50736C5.41421 7.8505 5.41421 11.6495 7.75736 13.9926C10.1005 16.3358 13.8995 16.3358 16.2426 13.9926C18.5858 11.6495 18.5858 7.8505 16.2426 5.50736Z" fill="#E2E2E2" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.60139 20.3009C8.71319 16.2148 15.3588 16.2356 19.4449 20.3474L18.381 21.4047C14.8788 17.8806 9.18291 17.8627 5.65872 21.3649L5.65872 21.3649M5.65872 21.3649L5.6189 21.4047C5.32693 21.6985 4.85206 21.7 4.55825 21.408C4.26444 21.116 4.26295 20.6412 4.55493 20.3474L4.60139 20.3009L4.60139 20.3009" fill="#E2E2E2" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.4246 4.57538C15.3241 0.474873 8.67589 0.474873 4.57538 4.57538C0.474873 8.67589 0.474873 15.3241 4.57538 19.4246C8.67589 23.5251 15.3241 23.5251 19.4246 19.4246C23.5251 15.3241 23.5251 8.67589 19.4246 4.57538ZM20.4853 3.51472C15.799 -1.17157 8.20101 -1.17157 3.51472 3.51472C-1.17157 8.20101 -1.17157 15.799 3.51472 20.4853C8.20101 25.1716 15.799 25.1716 20.4853 20.4853C25.1716 15.799 25.1716 8.20101 20.4853 3.51472Z" fill="#E2E2E2" />
            <defs>
              <clipPath id="clip0">
                <path d="M0 0H24V24H0V0Z" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="user-detail">
          <div class="user-name">
            <span class="typo-heading16 typo-medium skeleton-dark"></span>
          </div>
          <div class="shop-domain">
            <span class="typo-paragraph12 typo-regular skeleton-dark"></span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
// import UniversalSearch from "./UniversalSearch";
import { mapState } from "vuex";
export default {
  name: "Navigator",
  components: {
    // UniversalSearch
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpenHelpCenter: false,
      isOpenUserInfo: false,
      shouldHighlight: false,
      timeout: null
    };
  },
  computed: {
    // ...mapGetters("notibar", {
    //   notiBar: "notiBar"
    // }),
    ...mapState("agency", {
      agencyLogged: state => state.logged,
      info: state => state.info
    }),

    getTooltip() {
      return {
        helpCenter: this.isOpenHelpCenter ? false : this.$t("generals.helpCenter.toolTips")
      };
    }
  },
  watch: {},
  created() {
    this.checkSwitched();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  methods: {
    // ...mapActions("notibar", {
    //   openNotiCenter: "showNotificationBar",
    //   closeNotiCenter: "closeNotificationBar"
    // }),
    // openNoti() {
    //   this.openNotiCenter();
    //   this.closeUserInfo();
    //   this.closeHelpCenter();
    // },
    openHelpCenter() {
      this.isOpenHelpCenter = !this.isOpenHelpCenter;
      this.closeUserInfo();
      // this.closeNotiCenter();
    },
    closeHelpCenter() {
      this.isOpenHelpCenter = false;
    },
    openUserInfo() {
      this.isOpenUserInfo = !this.isOpenUserInfo;
      this.closeHelpCenter();
      // this.closeNotiCenter();
    },
    closeUserInfo() {
      this.isOpenUserInfo = false;
    },
    openLiveChat() {
      this.$chatbox.show();
      this.closeHelpCenter();
    },
    async checkSwitched() {
      let justSwitched = window.localStorage.justSwitched;
      if (justSwitched == true || justSwitched == "true") {
        this.isOpenUserInfo = true;
        await setTimeout(() => {}, 500);
        this.shouldHighlight = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.shouldHighlight = false;
          window.localStorage.removeItem("justSwitched");
        }, 5000);
      }
    }
    // getTooltip(title){
    //   switch (title) {
    //     case "helpCenter":
    //       if (this.isOpenHelpCenter) {
    //         console.log("here");
    //         return false
    //       }
    //       console.log("here 2");
    //       return this.$t('generals.helpCenter.toolTips')
    //     case "userInfo":
    //       if (this.isOpenHelpCenter) {
    //         return false
    //       }
    //       return `$t('accountSettings.headerTitle')`
    //     default: return false
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
// @import "@/core/themes/preload/navigator.scss";
i {
  font-size: 20px;
  color: $textDarkModeHigh;
}

.highlight {
  animation: blink 0.8s alternate linear infinite;
  position: relative;
  .highlight-tooltip {
    left: -194px;
    $pointer-size: 4px;

    font-size: 12px;
    line-height: 18px;
    background: $dark1;
    color: $textDarkModeHigh;
    padding: 3px 8px;
    max-width: 190px;
    position: absolute;
    border-radius: $radius;
    &:before {
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      content: "";

      border-top: $pointer-size solid transparent;
      border-bottom: $pointer-size solid transparent;
      border-left: $pointer-size solid $dark1;
      right: -$pointer-size;
      top: calc(50% - #{$pointer-size});
    }
  }
}

@keyframes blink {
  0% {
    box-shadow: unset;
  }
  50% {
    box-shadow: 0 0 7px 1px $accent-yellow;
  }
  100% {
    box-shadow: unset;
  }
}

.user-info {
  .button {
    min-width: 180px;
  }
}
</style>
